import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import { Table, Button } from "react-bootstrap";
import { Search } from "react-bootstrap-icons";

import { Loading } from "../../../common/loading/loading";
import { SimpleModal } from "../../../common/modal/simple-modal";
import { formatDate } from "../../../../utils/date-utils/date-utils";
import { EmailDetail } from "./e-mail-detail";

export const EmailTable = ({ rowNumberInit, emails, hasError }) => {
  const intl = useIntl();

  const [showEmail, setShowEmail] = useState(null);

  const TableBody = ({ emails, rowNumberInit }) => {
    if (emails.length === 0) {
      return (
        <tr>
          <td colSpan={6}>
            <span className="text-danger">
              <b>
                <FormattedMessage id="data.emails.warning.notfoundemails" />
              </b>
            </span>
          </td>
        </tr>
      );
    }

    return emails.map((email, index) => (
      <tr key={email.id}>
        <td className="col-rownumber">{rowNumberInit + index + 1}.</td>
        <td className="col-emailto">
          {email.to
            .filter((item) => !item.cc)
            .map((item) => `${item.name} (${item.address})`)
            .join(", ")}
        </td>
        <td className="col-emailcc">
          {email.to
            .filter((item) => item.cc)
            .map((item) => `${item.name} (${item.address})`)
            .join(", ")}
        </td>
        <td className="col-emailsubject">{email.subject}</td>
        <td className="col-date">{formatDate(new Date(email.date))}</td>
        <td className="col-status">
          <FormattedMessage
            id={`data.emails.form.status.value.${email.status}`}
          />{" "}
          ({email.statusDate})
        </td>
        <td className="col-actions">
          <Button
            variant="outline-secondary"
            title={intl.formatMessage({
              id: "page.emails.buttons.showemail",
            })}
            onClick={() => {
              setShowEmail(email);
            }}
          >
            <Search />
          </Button>
        </td>
      </tr>
    ));
  };

  const LoadingBody = ({ hasError }) => (
    <tr>
      <td colSpan={7}>
        {hasError ? (
          <span className="text-danger">
            <FormattedMessage id="data.emails.exception.listemails" />
          </span>
        ) : (
          <Loading />
        )}
      </td>
    </tr>
  );

  const EmailDetailModal = ({ email }) => (
    <SimpleModal
      title={intl.formatMessage({ id: "page.emails.label.email" })}
      handleClose={() => {
        setShowEmail(null);
      }}
    >
      <EmailDetail email={email} />
    </SimpleModal>
  );

  return (
    <>
      <div className="emails-table-component table-responsive">
        <Table striped bordered>
          <thead>
            <tr>
              <th className="col-rownumber">#</th>
              <th className="col-emailto">
                <FormattedMessage id="data.emails.form.to" />
              </th>
              <th className="col-emailcc">
                <FormattedMessage id="data.emails.form.cc" />
              </th>
              <th className="col-emailsubject">
                <FormattedMessage id="data.emails.form.subject" />
              </th>
              <th className="col-emaildate">
                <FormattedMessage id="data.emails.form.date" />
              </th>
              <th className="col-emailstatus">
                <FormattedMessage id="data.emails.form.status.label" />
              </th>
              <th className="col-actions"></th>
            </tr>
          </thead>
          <tbody>
            {emails ? (
              <TableBody emails={emails} rowNumberInit={rowNumberInit} />
            ) : (
              <LoadingBody hasError={hasError} />
            )}
          </tbody>
        </Table>
      </div>
      {showEmail ? <EmailDetailModal email={showEmail} /> : null}
    </>
  );
};

EmailTable.propTypes = {
  rowNumberInit: PropTypes.number.isRequired,
  emails: PropTypes.array,
  hasError: PropTypes.bool.isRequired,
};
